import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconSingleFile = (props) => (
  <SVG
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.3333 8.7375V15.8333C17.332 16.938 16.8926 17.997 16.1114 18.7782C15.3303 19.5593 14.2713 19.9987 13.1666 20H4.83329C3.72863 19.9987 2.66959 19.5593 1.88848 18.7782C1.10736 17.997 0.667949 16.938 0.666626 15.8333V4.16667C0.667949 3.06201 1.10736 2.00297 1.88848 1.22185C2.66959 0.440739 3.72863 0.00132716 4.83329 3.94844e-06H8.59579C9.36214 -0.00196849 10.1213 0.147994 10.8293 0.44122C11.5373 0.734446 12.1802 1.16512 12.7208 1.70834L15.6241 4.61334C16.1677 5.15354 16.5986 5.79622 16.892 6.50415C17.1854 7.21208 17.3354 7.97119 17.3333 8.7375ZM15.6666 8.7375C15.6666 8.6 15.64 8.46834 15.6275 8.33334H11.5C10.8369 8.33334 10.201 8.06995 9.73219 7.6011C9.26335 7.13226 8.99996 6.49638 8.99996 5.83334V1.70584C8.86496 1.69334 8.73246 1.66667 8.59579 1.66667H4.83329C4.17025 1.66667 3.53437 1.93006 3.06553 2.3989C2.59668 2.86774 2.33329 3.50363 2.33329 4.16667V15.8333C2.33329 16.4964 2.59668 17.1323 3.06553 17.6011C3.53437 18.0699 4.17025 18.3333 4.83329 18.3333H13.1666C13.8297 18.3333 14.4656 18.0699 14.9344 17.6011C15.4032 17.1323 15.6666 16.4964 15.6666 15.8333V8.7375Z"
      fill="#434B5D"
    />
  </SVG>
)

export default withIconStyles(IconSingleFile)
